import { render, staticRenderFns } from "./Feelings.vue?vue&type=template&id=40ad90fb&scoped=true"
import script from "./Feelings.vue?vue&type=script&lang=js"
export * from "./Feelings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ad90fb",
  null
  
)

export default component.exports